"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandPartnerService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const demand_partner_1 = require("./demand-partner");
const notification_service_1 = require("./notification.service");
const data_source_service_1 = require("./data-source.service");
let DemandPartnerService = class DemandPartnerService {
    constructor(_http, _talk, _dataSource) {
        this._http = _http;
        this._talk = _talk;
        this._dataSource = _dataSource;
        //declarations
        this.partnerURL = '/demandpartner';
        this.adUnitPartnerURL = '/adunitdemandpartner';
    }
    get(dataSource = 'biddr') {
        if (this._dataSource.isServerSideOrDealsOrConnect(dataSource)) {
            return this.rtbDemandPartners;
        }
        else {
            return this.demandPartners;
        }
    }
    // TODO: add RTB support
    getByCode(code) {
        for (let dP in this.demandPartners) {
            if (this.demandPartners[dP].code == code) {
                return this.demandPartners[dP];
            }
        }
        return new demand_partner_1.DemandPartner;
    }
    pull(dataSource = 'biddr') {
        return this._http.get(`${this.partnerURL}?dataSource=${dataSource}`)
            .toPromise()
            .then(response => response.json())
            .then(data => this.setPartnersData(dataSource, data))
            .catch(this._talk.handle);
    }
    /**
     * Pull the demand partners information from all data sources
     */
    pullAll() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.pull('biddr');
                yield this.pull('rtbx');
            }
            catch (err) {
                console.error('Unable to get partners data');
            }
        });
    }
    deletePartner(demandPartnerId) {
        return this._http.delete(`${this.adUnitPartnerURL}/${demandPartnerId}`)
            .toPromise();
    }
    setPartnersData(dataSource, data) {
        if (this._dataSource.isServerSideOrDealsOrConnect(dataSource)) {
            this.rtbDemandPartners = data;
        }
        else {
            this.demandPartners = data;
        }
    }
    updatePartner(demandPartnerId, updateData) {
        return this._http.post(`${this.adUnitPartnerURL}/${demandPartnerId}`, updateData).toPromise();
    }
    getGUID() {
        return this.demandPartners.map(dP => {
            return { code: dP.code, guid: dP.guid };
        });
    }
    getValidDemandPartnersCodes(dataSource) {
        if (this._dataSource.isServerSideOrDealsOrConnect(dataSource)) {
            // Currently, RTB partners 'code' it's 'displayName'
            return (this.rtbDemandPartners || []).map(dp => dp.displayName);
        }
        return (this.demandPartners || []).map(dp => dp.code.replace(/ /g, ''));
    }
};
exports.DemandPartnerService = DemandPartnerService;
exports.DemandPartnerService = DemandPartnerService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        data_source_service_1.DataSourceService])
], DemandPartnerService);
//# sourceMappingURL=demand-partner.service.js.map